import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  constructor() {}
  get(name: string): string | null {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find((row) => row.startsWith(name + '='));
    return cookie ? decodeURIComponent(cookie.split('=')[1]) : null;
  }

  set(name: string, value: string, days = 7): void {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/`;
  }

  delete(name: string): void {
    this.set(name, '', -1);
  }

  exists(name: string): boolean {
    return this.get(name) !== null;
  }

  clearAllCookies(): void {
    // Get all cookies
    const cookies = document.cookie.split('; ');

    // Iterate through all cookies and delete them
    for (const cookie of cookies) { 
      const name = cookie.split('=')[0];
      if(name == 'selectedLanguage'){
        this.delete(name);
      }
    }
  }
}
